<div style="border: 1px solid #bebebe;border-radius: 10px;padding: 5px;">
    <ion-grid>
        <!-- Table Heading -->
        <ion-row [ngClass]="isManagement ? 'management-heading' : 'heading'">
            <ion-col [ngClass]="isManagement ? 'management' : ''" size="3">
                &nbsp;
            </ion-col>
            <ion-col [ngClass]="isManagement ? 'management' : ''">
                Goals
            </ion-col>
            <ion-col [ngClass]="isManagement ? 'management' : ''">
                Principles
            </ion-col>
            <ion-col [ngClass]="isManagement ? 'management' : ''">
                Leadership
            </ion-col>
            <ion-col *ngIf="finalCalculated">
                {{ 'calibration.qtdQuestionsUsedForCalculate' | translate }}
            </ion-col>
            <ion-col [ngClass]="isManagement ? 'management' : ''">
                Final
            </ion-col>
        </ion-row>
        <ion-row [ngClass]="[ isManagement ? 'management-body' : 'body', anyCalculated ? 'small-text-size' : '' ]">
        <ion-col [ngClass]="isManagement ? 'management' : ''" size="3">
            <ion-grid>
                <ion-row>
                    <ion-col [ngClass]="[isManagement ? 'management management-first-col' : 'first-col']">
                        Self
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-col>
        <ion-col [ngClass]="isManagement ? 'management' : ''">
            <ion-grid>
                <ion-row>
                    <ion-col [ngClass]="isManagement ? 'management' : ''" *ngIf="goalsCalculated">
                        {{ _user?.selfEvaluation?.finalGoalsSelfEvaluationRelatedQuestionsUsed || '--' }}
                    </ion-col>
                    <ion-col [ngClass]="isManagement ? 'management' : ''" *ngIf="goalsCalculated">
                        {{ _user?.selfEvaluation?.finalGoalsSelfEvaluationFormula || '--' }}
                    </ion-col>
                    <ion-col [ngClass]="isManagement ? 'management' : ''">
                        <ng-container *ngIf="useTranslationOnOverallEvaluation; else useFinalGoalsSelf">
                            {{ _user?.selfEvaluation?.finalGoalsSelfEvaluationTranslated || '--' }}
                        </ng-container>
                        <ng-template #useFinalGoalsSelf>
                            {{ (_user?.selfEvaluation?.finalGoalsSelfEvaluation | translate) || '--' }}
                        </ng-template>
                    </ion-col>
                    <ion-col [ngClass]="isManagement ? 'management' : ''" *ngIf="principleCalculated">
                        {{ _user?.selfEvaluation?.finalPrinciplesSelfEvaluationRelatedQuestionsUsed|| '--' }}
                    </ion-col>
                    
                    <ion-col [ngClass]="isManagement ? 'management' : ''">
                        <ng-container *ngIf="useTranslationOnOverallEvaluation; else useFinalPrinciplesSelf">
                            {{ (_user?.selfEvaluation?.finalPrinciplesSelfEvaluationTranslated | translate) || '--' }}
                        </ng-container>
                        <ng-template #useFinalPrinciplesSelf>
                            {{ (_user?.selfEvaluation?.finalPrinciplesSelfEvaluation | translate) || '--' }}
                        </ng-template>
                    </ion-col>
                    <ion-col [ngClass]="isManagement ? 'management' : ''" *ngIf="finalCalculated">
                        {{ _user?.selfEvaluation?.finalSelfEvaluationRelatedQuestionsUsed || '--' }}
                    </ion-col>
                    
                    <ion-col [ngClass]="isManagement ? 'management' : ''">
                        {{ (_user?.selfEvaluation?.finalLeadershipSelfEvaluationTranslated | translate) || '--' }}
                    </ion-col>

                    <ion-col [ngClass]="isManagement ? 'management' : ''">
                        <ng-container *ngIf="useTranslationOnOverallEvaluation; else useFinalSelf">
                            {{ (_user?.selfEvaluation?.finalSelfEvaluationTranslated | translate) || '--' }}
                        </ng-container>
                        <ng-template #useFinalSelf>
                            {{ (_user?.selfEvaluation?.finalSelfEvaluation | translate) || '--' }}
                        </ng-template>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-col>
    </ion-row>
    <ion-row [ngClass]="[ isManagement ? 'management-body' : 'body', anyCalculated ? 'small-text-size' : '' ]">
        <ion-col [ngClass]="isManagement ? 'management' : ''" size="3">
            <ion-grid>
                <ion-row>
                    <ion-col [ngClass]="isManagement ? 'management management-first-col' : 'first-col'">
                        Manager
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-col>
        <ion-col [ngClass]="isManagement ? 'management' : ''" size="9">
            <ion-grid class="self-manager-evaluation">
                <ion-row>
                    <ion-col [ngClass]="isManagement ? 'management' : ''" *ngIf="goalsCalculated">
                        {{ _user?.managerEvaluation?.finalGoalsManagerEvaluationRelatedQuestionsUsed || '--' }}
                    </ion-col>
                    <!--                    <ion-col [ngClass]=isManagement ? 'management' : '' *ngIf="goalsCalculated">-->
                    <!--                        {{ _user?.managerEvaluation?.finalGoalsManagerEvaluationFormula }}-->
                    <!--                    </ion-col>-->
                    <ion-col [ngClass]="isManagement ? 'management' : ''">
                        <ng-container *ngIf="useTranslationOnOverallEvaluation; else useFinalGoalsManager">
                            {{ _user?.managerEvaluation?.finalGoalsManagerEvaluationTranslated || '--' }}
                        </ng-container>
                        <ng-template #useFinalGoalsManager>
                            {{ (_user?.managerEvaluation?.finalGoalsManagerEvaluation | translate) || '--' }}
                        </ng-template>
                    </ion-col>
                    <ion-col [ngClass]="isManagement ? 'management' : ''" *ngIf="principleCalculated">
                        {{ _user?.managerEvaluation?.finalPrinciplesManagerEvaluationRelatedQuestionsUsed || '--' }}
                    </ion-col>
                    <!--                    <ion-col [ngClass]=isManagement ? 'management' : '' *ngIf="principleCalculated">-->
                    <!--                        {{ _user?.managerEvaluation?.finalPrinciplesManagerEvaluationFormula }}-->
                    <!--                    </ion-col>-->
                    <ion-col [ngClass]="isManagement ? 'management' : ''">
                        <ng-container *ngIf="useTranslationOnOverallEvaluation; else useFinalPrinciplesManager">
                            {{ (_user?.managerEvaluation?.finalPrinciplesManagerEvaluationTranslated | translate) || '--' }}
                        </ng-container>
                        <ng-template #useFinalPrinciplesManager>
                            {{ (_user?.managerEvaluation?.finalPrinciplesManagerEvaluation | translate) || '--' }}
                        </ng-template>
                    </ion-col>

                    <ion-col [ngClass]="isManagement ? 'management' : null" *ngIf="finalCalculated">
                        {{ _user?.selfEvaluation?.finalSelfEvaluationRelatedQuestionsUsed || '--' }}
                    </ion-col>
                    <ion-col [ngClass]="isManagement ? 'management' : ''">
                        {{ (_user?.managerEvaluation?.finalLeadershipManagerEvaluationTranslated | translate) || '--' }}
                    </ion-col>
                    <ion-col [ngClass]="isManagement ? 'management' : ''">
                        <ng-container *ngIf="useTranslationOnOverallEvaluation; else useFinalManager">
                            {{ (_user?.managerEvaluation?.finalManagerEvaluationTranslated | translate) || '--' }}
                        </ng-container>
                        <ng-template #useFinalManager>
                            {{ (_user?.managerEvaluation?.finalManagerEvaluation | translate) || '--' }}
                        </ng-template>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-col>
    </ion-row>

    </ion-grid>
</div>